var _path, _rect, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensitiveAreaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M57 114C88.4802 114 114 88.4802 114 57C114 25.5198 88.4802 0 57 0C25.5198 0 0 25.5198 0 57C0 88.4802 25.5198 114 57 114Z",
    fill: "#FDDFCA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1148_9026",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 90,
    height: 90
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 90,
    height: 90,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1148_9026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 89.9063C56.2406 89.9063 55.4919 89.7547 54.7538 89.4516C54.0156 89.1491 53.3438 88.7022 52.7381 88.1109L25.8891 61.2619C25.2978 60.6563 24.8509 59.9844 24.5484 59.2463C24.2453 58.5081 24.0938 57.7594 24.0938 57C24.0938 56.2406 24.2453 55.4881 24.5484 54.7425C24.8509 53.9975 25.2978 53.3294 25.8891 52.7381L52.7381 25.8891C53.3438 25.2834 54.0156 24.8328 54.7538 24.5372C55.4919 24.2416 56.2406 24.0938 57 24.0938C57.7594 24.0938 58.5119 24.2416 59.2575 24.5372C60.0025 24.8328 60.6706 25.2834 61.2619 25.8891L88.1109 52.7381C88.7166 53.3294 89.1672 53.9975 89.4628 54.7425C89.7584 55.4881 89.9063 56.2406 89.9063 57C89.9063 57.7594 89.7584 58.5081 89.4628 59.2463C89.1672 59.9844 88.7166 60.6563 88.1109 61.2619L61.2619 88.1109C60.6706 88.7022 60.0025 89.1491 59.2575 89.4516C58.5119 89.7547 57.7594 89.9063 57 89.9063ZM58.6584 85.4353L85.4353 58.6584C85.8197 58.2741 86.0119 57.7213 86.0119 57C86.0119 56.2788 85.8197 55.7259 85.4353 55.3416L58.6584 28.5647C58.2741 28.1803 57.7213 27.9881 57 27.9881C56.2788 27.9881 55.7259 28.1803 55.3416 28.5647L28.5647 55.3416C28.1803 55.7259 27.9881 56.2788 27.9881 57C27.9881 57.7213 28.1803 58.2741 28.5647 58.6584L55.3416 85.4353C55.7259 85.8197 56.2788 86.0119 57 86.0119C57.7213 86.0119 58.2741 85.8197 58.6584 85.4353ZM55.125 61.3988H58.875V41.7834H55.125V61.3988ZM57 69.7641C57.63 69.7641 58.1722 69.5369 58.6266 69.0825C59.0809 68.6288 59.3081 68.0869 59.3081 67.4569C59.3081 66.8269 59.0809 66.2847 58.6266 65.8303C58.1722 65.3759 57.63 65.1488 57 65.1488C56.37 65.1488 55.8278 65.3759 55.3734 65.8303C54.9191 66.2847 54.6919 66.8269 54.6919 67.4569C54.6919 68.0869 54.9191 68.6288 55.3734 69.0825C55.8278 69.5369 56.37 69.7641 57 69.7641Z",
    fill: "#FF6B00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M42.5 67.5C27.9157 42.8221 59.4337 43.1001 58.7516 27.193C58.4065 19.2118 63.8175 33.5043 61.0892 30.1164L56.9983 26.0255C54.5429 26.0255 24.8555 56.2367 24.8555 58.167L36.543 70.5813C36.543 72.5116 54.0755 88.5579 58.7508 88.5579L87.9724 58.167C87.9724 58.167 61.7355 83.0546 43 68L42.5 67.5Z",
    fill: "#F96B21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensitiveAreaLogo);
export default __webpack_public_path__ + "static/media/sensitive_area_logo.cebdfeea781afc8ba6fa48c39819c405.svg";
export { ForwardRef as ReactComponent };